import { render, staticRenderFns } from "./SupportCard.vue?vue&type=template&id=7ce468e8&scoped=true"
import script from "./SupportCard.vue?vue&type=script&lang=js"
export * from "./SupportCard.vue?vue&type=script&lang=js"
import style0 from "./SupportCard.vue?vue&type=style&index=0&id=7ce468e8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ce468e8",
  null
  
)

export default component.exports